module.exports = __webpack_public_path__ + "img/video-shebei.3ed86cb0.jpg";